import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import template from './modules/template';
import products from './modules/products';
import substation from './modules/substation';
import spellgroup from './modules/spellgrouplist';
import cart from './modules/cart';
import order from './modules/order';
import seckill from './modules/seckilllist';
import buyfullpromotion from './modules/buyfullpromotionlist';
import awardwinuser from './modules/awardwinuser';
import favorites from './modules/favorites';
import giftcart from './modules/giftcart';
import user from './modules/user';
import chatserver from './modules/chatserver';
import session from './modules/session';
import marketingstaff from './modules/marketingstaff';
import voucherbagorder from './modules/voucherbagorder';
import distribution from './modules/distribution';
import pintuan from './modules/pintuan';
import bargain from './modules/bargain';
import addprice from './modules/addprice';
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        scrollTop: 0,
        classType:0//分类页展示模式
    },
    mutations: {
        setscroll(state, payload) {
            state.scrollTop = payload;
        }
    },
    actions: {

    },
    modules: {
        app,
        template,
        products,
        substation,
        spellgroup,
        cart,
        order,
        seckill,
        buyfullpromotion,
        awardwinuser,
        favorites,
        user,
        giftcart,
        chatserver,
        session,
        marketingstaff,
        voucherbagorder,
        distribution,
        pintuan,
        bargain,
        addprice
    },
});

export default store;
